import {IConfigurationEvaluationContext} from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IValueEvaluator} from '../value-evaluator.interface/value-evaluator.interface';
import {Check} from '@sparkware/app-utils';

export class SimpleValueEvaluator implements IValueEvaluator {
  constructor(private _value: any) {
  }

  get value(): any {
    return this._value;
  }

  private _evaluatedValue = undefined;

  evaluate(context: IConfigurationEvaluationContext): any {
    if(Check.isUndefined(this._evaluatedValue)) {
      this._evaluatedValue = context.applyValueTransformation(context.getCurrentPropertyPath(), this.value);
    }
    return this._evaluatedValue;
  }
}

